import React from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import FormHelperText from "@mui/material/FormHelperText";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";

import useAuth from "../../../hooks/useAuth";
import Input from "../../form/Input";
import { onKeyDown } from "./ClientAndProjectModal";

export default function ClientOnlyModal({ initialValues, onSubmit, onClose }) {
  const { user } = useAuth();
  const { settings } = user.company;

  const validationSchema = Yup.object().shape({
    clientName: Yup.string().required(`${settings.filter_field1} required`),
  });

  const formikOnSubmit = (values, { setErrors, setStatus, setSubmitting }) => {
    setSubmitting(true);
    const variables = { clientName: values.clientName };
    onSubmit({
      variables,
      onSuccess: () => {
        setSubmitting(false);
        setStatus({ success: true });
        onClose();
      },
      onFailure: errors => {
        setStatus({ success: false });
        setErrors(errors);
        setSubmitting(false);
      },
    });
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={formikOnSubmit}
    >
      {({ errors, isSubmitting, handleSubmit }) => (
        <Form>
          <Dialog open onClose={onClose} aria-labelledby="clientOnly" fullWidth maxWidth="xs">
            <DialogTitle id="clientOnly" sx={{ position: "relative" }}>
              <Typography variant="h2" color="textPrimary" align="center">
                {`New ${settings.filter_field1}`}
              </Typography>
              <IconButton onClick={onClose} sx={{ position: "absolute", right: 8, top: 8 }}>
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            <DialogContent>
              <Grid container spacing={1} sx={{ mt: 1 }}>
                <Grid size={12}>
                  <Input
                    autoFocus
                    name="clientName"
                    label={settings.filter_field1}
                    showNAButton={false}
                    inputProps={{ onKeyDown }}
                  />
                </Grid>
              </Grid>
              {errors.submit && (
                <Box mt={2}>
                  <FormHelperText error>{errors.submit}</FormHelperText>
                </Box>
              )}
            </DialogContent>
            <DialogActions sx={{ px: 3, pb: 2 }}>
              <Button
                key="create"
                variant="contained"
                color="primary"
                disabled={isSubmitting}
                type="submit"
                onClick={handleSubmit}
              >
                Create
              </Button>
            </DialogActions>
          </Dialog>
        </Form>
      )}
    </Formik>
  );
}
